// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a8e2cf31","453":"9b6ddbfc","455":"3b3a63c5"}[chunkId] + ".chunk.js";
};